"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var event_1 = require("../../util/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
var SHAPE_EVENT_MAP = {
    onColumnClick: 'interval:click',
    onColumnDblclick: 'interval:dblclick',
    onColumnMousemove: 'interval:mousemove',
    onColumnMousedown: 'interval:mousedown',
    onColumnMouseup: 'interval:mouseup',
    onColumnMouseenter: 'interval:mouseenter',
    onColumnMouseleave: 'interval:mouseleave',
    onColumnContextmenu: 'interval:contextmenu',
};
_.assign(event_1.EVENT_MAP, SHAPE_EVENT_MAP);
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/sparkline/tiny-column/event.js
// module id = 1014
// module chunks = 37